/* eslint-disable eslint-comments/disable-enable-pair, react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';

import { goToSlideAction, nextSlideAction } from 'src/redux/actions/slider';
import SearchForm from 'src/containers/Search/SearchForm';
import SlideContainer from 'src/containers/SlideContainer';
import SlidesIndicators from 'src/components/SlidesIndicators';
import styles from 'src/containers/SliderContainer.scss';


const timePerSlide = 10000;

class SliderContainer extends Component {
  sliderTimer = null;

  sliderReference = React.createRef();

  startAutoSlides = () => {
    const { nextSlide } = this.props;
    this.sliderTimer = setInterval(nextSlide, timePerSlide);
  };

  stopAutoSlides = () => {
    clearInterval(this.sliderTimer);
  };

  resetAutoSlides = () => {
    this.stopAutoSlides();
    this.startAutoSlides();
  };

  checkIfDisplayed = () => {
    const slider = this.sliderReference.current;
    if (!slider) return;

    if (window.getComputedStyle(slider).display === 'none') {
      this.stopAutoSlides();
    } else {
      this.resetAutoSlides();
    }
  };

  componentDidMount() {
    window.addEventListener('DOMContentLoaded', this.checkIfDisplayed);
    window.addEventListener('resize', this.checkIfDisplayed);
  }

  componentWillUnmount() {
    this.stopAutoSlides();
    window.removeEventListener('DOMContentLoaded', this.checkIfDisplayed);
    window.removeEventListener('resize', this.checkIfDisplayed);
  }

  render() {
    const { props: { slides, active, goToSlide }, resetAutoSlides } = this;
    const indicatorsAction = (slide) => {
      goToSlide(slide);
      resetAutoSlides();
    };

    return (
      <div data-test="slider-wrapper" styleName="slider-wrapper">
        <div styleName="empty-box" />
        <div
          ref={ this.sliderReference }
          data-test="slider"
          styleName="slider"
        >
          <LazyLoad height="26vw" resize>
            <div styleName="slider__slides">
              {slides.map((slide, index) => (
                <div
                  key={ slide.id }
                  className={ classNames({ [styles.slide__active]: active === index }) }
                  data-test="slider-slide"
                  styleName="slide"
                >
                  <SlideContainer { ...slide } />
                </div>
              ))}
            </div>

          </LazyLoad>
        </div>

        <div styleName="slider__search">

          <div styleName="slider__indicators">
            <SlidesIndicators action={ indicatorsAction } active={ active } count={ slides.length } />
          </div>

          <SearchForm />

        </div>
      </div>
    );
  }
}


SliderContainer.propTypes = {
  active: PropTypes.number.isRequired,
  goToSlide: PropTypes.func.isRequired,
  nextSlide: PropTypes.func.isRequired,
  slides: PropTypes.arrayOf(Object).isRequired
};

const mapStateToProperties = ({ sliderReducer }) => ({
  slides: sliderReducer.slides,
  active: sliderReducer.active
});

const mapDispatchToProperties = dispatch => ({
  goToSlide: slideNumber => dispatch(goToSlideAction(slideNumber)),
  nextSlide: () => dispatch(nextSlideAction())
});

export { SliderContainer };
export default connect(mapStateToProperties, mapDispatchToProperties)(SliderContainer);
